import { MiniAppFetchError } from '../../_shared/fetch-error';

/**
 * Structured 429 detection — checks the typed `status` field on
 * `MiniAppFetchError` rather than string-sniffing `err.message`. A prior
 * version of the bulk-upload retry loop did `err.message.includes('429')`,
 * which silently broke whenever the fetch wrapper threw a non-`Error` value
 * (message empty → never matched, no signal). It only "worked" by accident
 * because `MiniAppFetchError extends Error` and, for a non-JSON 429 body, its
 * message used to be `http_429:429` (plan 2026-09-28-008 U4 changed that
 * fallback to a generic sentence — reading `.status` instead of `.message`
 * was already the right fix regardless, and stays so).
 *
 * Kept in its own plain `.ts` module (not inline in `BulkUploadModal.tsx`)
 * so it can be unit-tested from `mini-apps/launcher/__tests__/` without
 * pulling a `.tsx` (JSX) module into the `tsconfig.tests.json` compile graph
 * — that config has no `--jsx` flag set (it type-checks backend + test
 * files) and fails with TS6142 on any `.tsx` import.
 */
export function isRateLimited(err: unknown): boolean {
  return err instanceof MiniAppFetchError && err.status === 429;
}
